import React, { createContext, useContext, useState, useEffect } from 'react';

const SdpModeContext = createContext();

export const useSdpMode = () => {
    const context = useContext(SdpModeContext);
    if (!context) {
        throw new Error('useSdpMode must be used within SdpModeProvider');
    }
    return context;
};

export const SdpModeProvider = ({ children }) => {
    // Initialize from localStorage or default to 'off'
    const [sdpMode, setSdpModeState] = useState(() => {
        try {
            const stored = localStorage.getItem('sdpMode');
            return stored || 'off';
        } catch (error) {
            console.error('Error reading from localStorage:', error);
            return 'off';
        }
    });

    // Wrapper function to update both state and localStorage
    const setSdpMode = (newMode) => {
        setSdpModeState(newMode);
        
        try {
            if (newMode === 'off') {
                // Clear all SDP-related data when mode is turned off
                localStorage.removeItem('sdpMode');
                localStorage.removeItem('sessionSettings');
            } else {
                // Save mode to localStorage
                localStorage.setItem('sdpMode', newMode);
            }
        } catch (error) {
            console.error('Error writing to localStorage:', error);
        }
    };

    return (
        <SdpModeContext.Provider value={{ sdpMode, setSdpMode }}>
            {children}
        </SdpModeContext.Provider>
    );
};
